import {
  ValidatedClaimsetProvider,
  OpenIdKeysetProvider,
  OpenIdEndpointProvider,
} from '@trimble-oss/trimble-id';
import { Claimset } from '@trimble-oss/trimble-id/Claimset';

const WELL_KNOWN_ENDPOINT_STG =
  'https://stage.id.trimblecloud.com/.well-known/openid-configuration';
const WELL_KNOWN_ENDPOINT =
  'https://id.trimble.com/.well-known/openid-configuration';

export async function decodeJwt(
  token: string,
  environment: 'stg' | 'prod'
): Promise<Claimset> {
  const wellKnownEndpoint =
    environment === 'stg' ? WELL_KNOWN_ENDPOINT_STG : WELL_KNOWN_ENDPOINT;
  const endpointProvider = new OpenIdEndpointProvider(wellKnownEndpoint);
  const keysetProvider = new OpenIdKeysetProvider(endpointProvider);
  const validatedClaimsetProvider = new ValidatedClaimsetProvider(
    keysetProvider
  );

  const CLOCK_SKEW_SECONDS = 300; // 5 minutes

  const claimset = await validatedClaimsetProvider
    .WithTokenValidation(true)
    .WithClockSkew(CLOCK_SKEW_SECONDS)
    .RetrieveClaimset(token);
  return claimset;
}
